import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;

  > .card {
    flex: 1;
    height: 100%;
    width: 100%;
    max-width: 340px;
    cursor: pointer;
  }

  @media (max-width: 680px) {
    flex-direction: column;

    > .card {
      max-width: unset;
      min-height: 140px;
    }
  }
`
